import React from "react";
import { UK_INTAKE_WHATSAPP_URL } from "@/lib/contact";
import { track } from "@/lib/analytics";

/**
 * Floating WhatsApp widget — anchored bottom-right across the entire site.
 * Sits above the Emergent badge (or where it would be on free plans) and
 * clears any sticky CTA buttons above it.
 */
export const FloatingWhatsApp = () => {
  return (
    <a
      href={UK_INTAKE_WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Book a priority assessment on WhatsApp"
      onClick={() => track("floating_whatsapp_clicked")}
      className="
        fixed z-[60]
        bottom-[88px] right-4
        sm:bottom-[96px] sm:right-6
        inline-flex items-center gap-2 group
        bg-[#25D366] hover:bg-[#1ebe57] active:bg-[#19a64b]
        text-white rounded-full
        pl-3 pr-4 py-3
        shadow-[0_8px_24px_rgba(37,211,102,0.35)]
        ring-1 ring-black/5
        transition-all
      "
    >
      <span
        aria-hidden
        className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-white/15"
      >
        {/* Inline WhatsApp glyph — lightweight & doesn't depend on lucide */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          fill="currentColor"
          className="w-5 h-5"
        >
          <path d="M19.11 17.39c-.3-.15-1.78-.88-2.06-.98-.28-.1-.48-.15-.68.15-.2.3-.78.98-.95 1.18-.17.2-.35.22-.65.07-.3-.15-1.27-.47-2.42-1.5-.9-.8-1.5-1.8-1.68-2.1-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.68-1.64-.93-2.25-.24-.59-.49-.51-.68-.52l-.58-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.06 2.88 1.21 3.08c.15.2 2.09 3.19 5.07 4.47.71.3 1.26.48 1.69.62.71.22 1.36.19 1.87.12.57-.09 1.78-.73 2.03-1.42.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35Zm-5.43 7.36h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-4.02 1.05 1.07-3.92-.25-.4a10.59 10.59 0 1 1 8.99 4.98ZM16 4.5A11.45 11.45 0 0 0 5.92 21.86L4.5 27l5.27-1.38A11.42 11.42 0 0 0 16 27.5 11.5 11.5 0 0 0 16 4.5Z" />
        </svg>
      </span>
      <span className="hidden sm:inline text-sm font-semibold tracking-tight">
        Chat on WhatsApp
      </span>
    </a>
  );
};

export default FloatingWhatsApp;
